import Axios from 'axios';
import Vue from 'vue';
import Router from 'vue-router';
import store from './components/store';
import findPlateNumber from './view/findPlateNumber';
import login from './view/login';
import paying from './view/paying';
import payment from './view/payment';
// import wx from 'weixin-js-sdk';

Vue.use(Router);

const routes = [
  {
    name: 'find_plate_number',
    component: findPlateNumber,
    meta: {
      title: '查询车牌',
    }
  },
  {
    name: 'q',
    component: findPlateNumber,
    meta: {
      title: '查询车牌',
    }
  },
  {
    name: 'login',
    component: login,
    meta: {
      title: 'U泊停车',
      withoutAuth: true
    }
  },
  {
    name: 'scan',
    component: () => import('./view/scan'),
    meta: {
      title: '扫一扫'
    }
  },
  {
    name: 'parking_spot',
    component: () => import('./view/parkingSpot'),
    meta: {
      title: '车位信息'
    }
  },
  {
    name: 'parking',
    component: () => import('./view/parking'),
    meta: {
      title: '计费中'
    }
  },
  {
    name: 'paying',
    component: paying,
    meta: {
      title: '结算停车费'
    }
  },
  {
    name: 'coupons',
    component: () => import('./view/coupons'),
    meta: {
      title: '优惠券'
    }
  },
  {
    name: 'payment',
    component: payment,
    meta: {
      title: '支付'
    }
  },
  {
    name: 'leaving',
    component: () => import('./view/leaving'),
    meta: {
      title: '支付完成'
    }
  },
  {
    name: 'orders',
    component: () => import('./view/orders'),
    meta: {
      title: '停车记录'
    }
  },
  {
    name: 'lease_cards',
    component: () => import('./view/leaseCards'),
    meta: {
      title: '我的月租卡'
    }
  },
  {
    name: 'lease_card',
    component: () => import('./view/leaseCard'),
    meta: {
      title: '月卡信息'
    }
  },
  {
    name: 'lease_card_register',
    component: () => import('./view/leaseCardRegister'),
    meta: {
      title: '月租申请'
    }
  },
  {
    name: 'lease_confirm',
    component: () => import('./view/leaseConfirm'),
    meta: {
      title: '月租信息确认'
    }
  },
  {
    name: 'invoices',
    component: () => import('./view/invoices'),
    meta: {
      title: '发票申请记录'
    }
  },
  {
    name: 'invoice',
    component: () => import('./view/invoice'),
    meta: {
      title: '发票申请详情'
    }
  },
  {
    name: 'invoice_apply',
    component: () => import('./view/invoiceApply'),
    meta: {
      title: '发票申请'
    }
  },
  {
    name: 'pay_for_friend',
    component: () => import('./view/payForFriend'),
    meta: {
      title: '好友代付'
    }
  },
  {
    name: 'gi',
    component: () => import('./view/gateIdentify'),
    meta: {
      title: '无牌车识别'
    }
  },
  {
    name: 'spot_manage',
    component: () => import('./view/spotManage'),
    meta: {
      title: '车位管理'
    }
  },
  {
    name: 'rd',
    component: () => import('./view/rd'),
    meta: {
      title: '加载中....'
    }
  },
  {
    name: 'close_window',
    component: () => import('./view/closeWindow'),
    meta: {
      title: '退出中....'
    }
  }
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ mode: 'history', routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  const withoutAuth = to.meta && to.meta.withoutAuth;

  const callback = window.location.pathname + window.location.search;
  const redirect = '/login?redirect_uri=' + encodeURIComponent(callback)
  const token = localStorage.getItem('token');

  // 不需要验证或有登录信息都可以直接跳转
  if (withoutAuth || store.state.user || window.location.pathname==='/login') {
    next();
  } else if (token) {
    Axios.get('/json/member/base', {headers: {'X-Token': token}})
      .then(resp => {
        if (resp) {
          store.setUser(resp.data);
          next();
        } else {
          next(false);
        }
       
      })
      .catch(error => {
        const status = error && error.response && error.response.status;
        if (status === 401) {
          next(redirect);
        } else {
          next(false);
        }
      });
  } else {
    // 否则需要先重定向到登录,再跳转回来
    next(redirect);
  }
  
});

export {
  router
};